import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = comprobando, false = no autenticado, objeto = usuario
  const [user, setUser] = useState(null);
  const [expired, setExpired] = useState(false);

  useEffect(() => {
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false));
  }, []);

  useEffect(() => {
    const onExpired = () => {
      localStorage.removeItem("ap_session_exp");
      setUser((u) => {
        if (u) setExpired(true); // había sesión iniciada → mostrar aviso en login
        return false;
      });
    };
    window.addEventListener("auth:expired", onExpired);
    return () => window.removeEventListener("auth:expired", onExpired);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.requires_2fa) return data;
    setExpired(false);
    setUser(data);
    return data;
  }, []);

  const verify2fa = useCallback(async (code) => {
    const { data } = await api.post("/auth/2fa/verify", { code });
    setExpired(false);
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      localStorage.removeItem("ap_session_exp");
      setUser(false);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, expired, setExpired, login, verify2fa, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
